// The inbox's closed sets and limits, which the app shares.

// The kinds of event that inbox_events records and the activity feed and the inbox show.
export const ACTIVITY_EVENT_KINDS = [
  "opened",
  "moved",
  "status_line",
  "linked",
  "unlinked",
  "commented",
  "archived",
  "unarchived",
  "action_started",
  "user_added",
  "user_removed",
  "task_created",
  "task_updated",
  "task_status_changed",
  "task_user_added",
  "task_user_removed",
  "task_tagged",
  "task_untagged",
  "task_archived",
  "task_unarchived",
  "task_blocker_added",
  "task_blocker_removed",
  "task_review_approved",
  "task_review_changes_requested",
  "task_review_commented",
  "task_review_requested",
  "task_review_withdrawn",
  "canvas_file_added",
  "canvas_file_removed",
  "file_renamed",
  "file_edited",
  "file_version_restored",
  "file_deleted",
  "file_restored",
] as const;
export type ActivityEventKind = (typeof ACTIVITY_EVENT_KINDS)[number];

// Why a user got an inbox notification, highest priority first. One event
// that reaches a user for several reasons shows once, under the first.
export const INBOX_REASONS = [
  "review",
  "mention",
  "reply",
  "assignee",
  "owner",
  // On a project a Library file is attached to.
  "member",
  // Favorited the Library file.
  "favorite",
] as const;
export type InboxReason = (typeof INBOX_REASONS)[number];

// What settled a notification after it reached the user: they replied in its thread or reviewed its task, or its thread was resolved.
export const INBOX_RESPONSE_KINDS = [
  "replied",
  "resolved",
  "approved",
  "changes_requested",
] as const;
export type InboxResponseKind = (typeof INBOX_RESPONSE_KINDS)[number];

// What the inbox's type filter offers.
export const INBOX_NOTIFICATION_TYPES = [
  "review",
  "mention",
  "reply",
  "comment",
  "agent",
  "assignment",
  "status",
  "edit",
] as const;
export type InboxNotificationType = (typeof INBOX_NOTIFICATION_TYPES)[number];

// The inbox's source filter value for the agent; any other source is a user id.
export const INBOX_AGENT_SOURCE = "agent";

// The most notifications an inbox holds, newest first. Nobody works through more.
export const INBOX_LIMIT = 1000;
